import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

@Component({
  selector: "card-form",
  templateUrl: "./card-form.component.html",
  styleUrls: ["./card-form.component.scss"]
})
export class CardFormComponent implements OnInit {
  @Input()
  amount: number;

  @Input()
  totalAmount: number;

  @Input()
  amountStatus: string;

  @Input()
  currency: string;

  @Output() cardSubmitted = new EventEmitter();
  @Output() cancelled = new EventEmitter();

  months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  years = [];
  form: UntypedFormGroup;
  minDate = new Date();
  maxDate = new Date();

  constructor(public formBuilder: UntypedFormBuilder) {
    this.years = this.generateYears();
    this.maxDate = new Date();
    this.maxDate.setFullYear(new Date().getFullYear() + 10);
    this.form = this.formBuilder.group({
      holderName: [null, Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(26)])],
      expiryDate: [null, Validators.compose([Validators.required])],
      CVV: [null, Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(3)])],
      cardNumber: [null, Validators.compose([Validators.required, Validators.minLength(16), Validators.maxLength(16)])]
    });
  }

  ngOnInit(): void {
    //
  }

  generateYears(): number[] {
    const today = new Date();
    const thisYear = today.getFullYear();
    const yearsArray = [thisYear];
    const newYear = thisYear + 10;
    let currentYear = thisYear + 1;
    while (currentYear < newYear) {
      yearsArray.push(currentYear);
      currentYear += 1;
    }
    yearsArray.push(newYear);
    return yearsArray;
  }

  onPayClicked(): void {
    this.cardSubmitted.emit();
  }
  onCancelClicked(): void {
    this.cancelled.emit();
  }
}
